import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const LandingNav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <motion.nav 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? 'navbar-scrolled' : 'bg-background/70 backdrop-blur-sm'
      } border-b border-border/50`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <button 
            onClick={() => scrollToSection('hero')}
            className="flex items-center gap-3 hover:opacity-80 transition-opacity"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_explore-elsewhere/artifacts/3xxh7ml4_Podcast%20Logo%20Babes%2C%20How%20Did%20You%20Get%20Here%20%284%29.png"
              alt="A Life Elsewhere"
              className="h-12 w-auto"
            />
          </button>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('community')} className="text-sm font-medium text-foreground hover:text-primary transition-colors">Community</button>
            <button onClick={() => scrollToSection('episodes')} className="text-sm font-medium text-foreground hover:text-primary transition-colors">Episodes</button>
            <button onClick={() => scrollToSection('guests')} className="text-sm font-medium text-foreground hover:text-primary transition-colors">Stories</button>
            <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-foreground hover:text-primary transition-colors">About</button>
            <button onClick={() => scrollToSection('sponsors')} className="text-sm font-medium text-foreground hover:text-primary transition-colors">Sponsors</button>
            <Button onClick={() => scrollToSection('hero')} className="rounded-full btn-premium">Join Community</Button>
          </div>

          <button className="md:hidden p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {mobileMenuOpen && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} className="md:hidden pb-4">
            <div className="flex flex-col gap-4">
              <button onClick={() => scrollToSection('community')} className="text-left py-2">Community</button>
              <button onClick={() => scrollToSection('episodes')} className="text-left py-2">Episodes</button>
              <button onClick={() => scrollToSection('guests')} className="text-left py-2">Stories</button>
              <button onClick={() => scrollToSection('about')} className="text-left py-2">About</button>
              <button onClick={() => scrollToSection('sponsors')} className="text-left py-2">Sponsors</button>
              <Button onClick={() => scrollToSection('hero')} className="w-full rounded-full btn-premium">Join Community</Button>
            </div>
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
};

export default LandingNav;